import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Col, Row, Modal } from '_zari/core'

import Yup from '_zari/validation/_yup'

import DescuentoMontoFormGroup from './formGroups/descuentoMonto'
import DescuentoPorcentajeFormGroup from './formGroups/descuentoPorcentaje'

const ValidationSchema = Yup.object().shape({
  descuentoMonto: Yup.number()
    .min(0)
    .notRequired(),
  descuentoPorcentaje: Yup.number()
    .min(0)
    .max(100)
    .notRequired()
})

const AplicarDescuentoModal = ({ handleClose, show, modalData, actualizarDescuentoHandler }) => {
  const formInitialValues = React.useMemo(
    () => ({
      descuentoMonto: modalData.descuentoMonto || '',
      descuentoPorcentaje: modalData.descuentoPorcentaje || '',
      aplicarTodos: false
    }),
    [modalData]
  )

  const submitHandler = async data => {
    actualizarDescuentoHandler(data)
  }

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>ACTUALIZAR DESCUENTO</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={formInitialValues}
        onSubmit={submitHandler}
        validationSchema={ValidationSchema}
      >
        {({ errors, handleSubmit, handleChange, isSubmitting, setValues, touched, values }) => (
          <Form>
            <Modal.Body>
              <Row>
                <Col md={12}>
                  <DescuentoMontoFormGroup
                    iError={errors.descuentoMonto}
                    iTouched={touched.descuentoMonto}
                    fIsSubmitting={isSubmitting}
                    values={values}
                    setValues={setValues}
                    handleChange={handleChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <DescuentoPorcentajeFormGroup
                    iError={errors.descuentoPorcentaje}
                    iTouched={touched.descuentoPorcentaje}
                    fIsSubmitting={isSubmitting}
                    values={values}
                    setValues={setValues}
                    handleChange={handleChange}
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>A fila</Button>
              <Button
                onClick={e => {
                  e.preventDefault()
                  submitHandler({ ...values, aplicarTodos: true })
                }}
              >
                A todo
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(AplicarDescuentoModal)
